module.exports = __webpack_public_path__ + "img/스펠소드.69c16351.png";